import $ from "../jquery_global";

// Map Products filter form: date range must be at most 1 calendar month.
(function () {
  var MAX_RANGE_MESSAGE = 'Date range cannot be more than 1 month. Please choose a shorter range.';

  function parseDate(value) {
    if (!value) return null;
    var parts = value.split('-');
    if (parts.length !== 3) return null;
    return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
  }

  function addOneMonth(date) {
    var limit = new Date(date.getTime());
    limit.setMonth(limit.getMonth() + 1);
    return limit;
  }

  function isValidDateRange(fromStr, toStr) {
    var from = parseDate(fromStr);
    var to = parseDate(toStr);
    if (!from || !to) return { valid: false, message: 'Please select both From Date and To Date.' };
    if (to < from) return { valid: false, message: 'To Date must be on or after From Date.' };
    if (to > addOneMonth(from)) {
      return { valid: false, message: MAX_RANGE_MESSAGE };
    }
    return { valid: true };
  }

  function showDateRangeError($form, message) {
    var $wrap = $form.find('.js-mp-date-range-error-wrap');
    var $error = $form.find('.js-mp-date-range-error');
    $error.text(message);
    $wrap.removeClass('d-none');
  }

  function clearDateRangeError($form) {
    $form.find('.js-mp-date-range-error').text('');
    $form.find('.js-mp-date-range-error-wrap').addClass('d-none');
  }

  $(document).on('submit', '.js-mp-filters-form', function (e) {
    var $form = $(this);
    var fromStr = $form.find('[name="from_date"]').val();
    var toStr = $form.find('[name="to_date"]').val();
    var result = isValidDateRange(fromStr, toStr);

    if (!result.valid) {
      e.preventDefault();
      showDateRangeError($form, result.message);
      return;
    }

    clearDateRangeError($form);
  });

  $(document).on('change', '.js-mp-filters-form [name="from_date"], .js-mp-filters-form [name="to_date"]', function () {
    clearDateRangeError($(this).closest('.js-mp-filters-form'));
  });
})();

// XHR link handler for the Map Products page.
// Links with class `js-xhr-replace` and `data-target="<selector>"` swap
// only that element instead of doing a full-page navigation.

$(document).on('click', '.js-xhr-replace', function (e) {
  e.preventDefault();

  var $link     = $(this);
  var targetSel = $link.data('target');
  var $target   = $(targetSel);
  var url       = $link.attr('href');

  if (!$target.length || !url) return;

  $target.css('opacity', 0.5);

  $.ajax({
    url: url,
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
    },
    success: function (html) {
      $target.css('opacity', 1).html(html);
    },
    error: function () {
      $target.css('opacity', 1);
    }
  });
});

// Debounced search for map-products tabs.
// Inputs with class `js-mp-search` carry `data-search-url` (base URL without search param)
// and `data-target` (the container selector to replace).
(function () {
  var timer = null;
  var DEBOUNCE_MS = 500;

  $(document).on('input', '.js-mp-search', function () {
    var $input    = $(this);
    var baseUrl   = $input.data('search-url');
    var targetSel = $input.data('target');
    var $target   = $(targetSel);
    var query     = $input.val().trim();

    if (!$target.length || !baseUrl) return;

    clearTimeout(timer);
    timer = setTimeout(function () {
      var separator = baseUrl.indexOf('?') === -1 ? '?' : '&';
      var url = query ? baseUrl + separator + 'search=' + encodeURIComponent(query) : baseUrl;

      $target.css('opacity', 0.5);

      $.ajax({
        url: url,
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        success: function (html) {
          $target.css('opacity', 1).html(html);
          var $newInput = $target.find('.js-mp-search');
          if ($newInput.length) {
            $newInput.focus();
            $newInput[0].setSelectionRange(query.length, query.length);
          }
        },
        error: function () {
          $target.css('opacity', 1);
        }
      });
    }, DEBOUNCE_MS);
  });
})();

// Client-side confidence filter for Needs Review / Auto-mapped tabs.
// Reads data-confidence on each .mp-nr-row and shows/hides based on the
// selected bucket in .js-mp-confidence-filter.
$(document).on('change', '.js-mp-confidence-filter', function () {
  var bucket = $(this).val();
  var $table = $(this).closest('.mp-nr-toolbar, .mp-search-toolbar').siblings('.mp-table-wrap').first();
  var $rows  = $table.find('.mp-nr-row');

  $rows.each(function () {
    var $row   = $(this);
    var conf   = parseFloat($row.data('confidence')) || 0;
    var $panel = $table.find('[data-panel-for="' + $row.data('row-id') + '"]');
    var show   = true;

    if (bucket === 'high')       show = conf >= 0.80;
    else if (bucket === 'medium') show = conf >= 0.40 && conf < 0.80;
    else if (bucket === 'low')    show = conf < 0.40;

    $row.toggleClass('d-none', !show);
    if ($panel.length) $panel.toggleClass('d-none', !show);
  });
});
